module.exports = __webpack_public_path__ + "static/Entypo-744ce60078c17d86006dd0edabcd59a7.ttf";